import { ErreurApi } from '../../lib/api';
import { dateReunion } from '../../lib/useFormateurs';

/** Champs et boutons des réglages, aux dimensions tactiles de la plateforme. */
export const CLASSE_CHAMP_NOMBRE =
  'min-h-[44px] w-24 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-codialis-navy focus:border-codialis-sky focus:outline-none focus:ring-2 focus:ring-codialis-sky/20 disabled:opacity-60';

export const CLASSE_BOUTON_ENREGISTRER =
  'min-h-[44px] rounded-xl bg-codialis-navy px-4 text-sm font-semibold text-white transition hover:bg-codialis-deep disabled:opacity-50';

export function messageErreur(erreur: unknown, repli: string): string {
  return erreur instanceof ErreurApi ? erreur.message : repli;
}

/** « Réglé par Marie Hoarau le 22/10/2026 », ou la valeur par défaut. */
export function mentionReglage(reglage: { parDefaut: boolean; regleLe: string | null; reglePar: string | null }): string {
  if (reglage.parDefaut || !reglage.regleLe) return 'Valeur par défaut, jamais réglée.';
  return `Réglé${reglage.reglePar ? ` par ${reglage.reglePar}` : ''} le ${dateReunion(reglage.regleLe)}.`;
}
